import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';
import { MainJobModule } from './../../jobs/main-job/main-job.module';
import { MainStaffRoutingModule } from './main-staff-routing.module';
import { MainTimesheetModule } from './../../time-sheet/main-timesheet/main-timesheet.module';
// IMPORT STAFF MODULE COMPONENTS

import { MainStaffComponent } from './main-staff.component';
import { StaffComponent } from '../staff.component';
import { AddStaffModalComponent } from '../add-staff-modal/add-staff-modal.component';
import { EditStaffModalComponent } from '../edit-staff-modal/edit-staff-modal.component';
import { SingleStaffComponent } from '../single-staff/single-staff.component';
import { CompetencesComponent } from '../competences/competences.component';
import { AddCompModalComponent } from '../competences/add-comp-modal/add-comp-modal.component';
import { PendingStaffComponent } from '../pending-staff/pending-staff.component';


@NgModule({
  declarations: [
    MainStaffComponent,
    StaffComponent,
    AddStaffModalComponent,
    EditStaffModalComponent,
    SingleStaffComponent,
    CompetencesComponent,
    AddCompModalComponent,
    PendingStaffComponent
  ],
  imports: [
    CommonModule,
    MainStaffRoutingModule,
    SharedModule,
    MaterialsModule,
    MainJobModule,
    MainTimesheetModule
  ],
  entryComponents: [
    AddStaffModalComponent,
    EditStaffModalComponent
  ],
  exports: [
    StaffComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainStaffModule { }
